import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.variant  = this.getData('variant') || 'default';
        this.showMore = this.getData('show-more') === 'true';
    }

    setResults({ hits, nbHits, query, baseUrl, lang }) {
        if (!hits || !hits.length) {
            const msg = lang === 'en' ? `No results for "${query}"` : `Aucun résultat pour « ${query} »`;
            this.el.innerHTML = `<div class="c-search-results_empty">
                <span class="c-search-results_empty_text">${this.escapeHtml(msg)}</span>
            </div>`;
            this.show();
            return;
        }

        const items = hits.map(hit => this.renderHit(hit)).join('');

        let extras = '';

        if (this.showMore && nbHits > hits.length) {
            const label = lang === 'en' ? 'More results' : 'Plus de résultats';
            extras += `<a class="c-search-results_item -more" href="${baseUrl}?s=${encodeURIComponent(query)}">
                <span class="c-search-results_item_title">${label}</span>
            </a>`;
        }

        this.el.innerHTML = items + extras;
        this.show();
    }

    escapeHtml(str) {
        const el = document.createElement('span');
        el.textContent = str;
        return el.innerHTML;
    }

    renderHit(hit) {
        const rawUrl = hit.url || hit.slug || '';
        const title  = hit?._highlightResult?.title?.value || hit.title || hit.name || '';
        const url    = rawUrl ? (/^https?:\/\//i.test(rawUrl) || rawUrl.startsWith('/') ? rawUrl : `/${rawUrl}`) : '#';

        return `<a class="c-search-results_item" href="${url}">
            <span class="c-search-results_item_title">${title}</span>
        </a>`;
    }

    show() {
        this.el.removeAttribute('hidden');
        requestAnimationFrame(() => {
            this.el.classList.add('is-open');
        });
    }

    clear() {
        this.el.innerHTML = '';
        this.el.setAttribute('hidden', '');
        this.el.classList.remove('is-open');
    }
}
